import TasksOverview from "./TasksOverview"
import ResourceParticipation from "./ResourceParticipation"

import { Card, CardContent, makeStyles, Theme, Typography, CardHeader } from "@material-ui/core"
import { APP_MAX_WIDTH, COLOR_GRAY } from "../../../constants"
import { ProjectDashboardViewModel } from "../../api/project-dashboard"
import { useTranslations } from "./useTranslations"
import { useIsSmallScreen } from "../../../hooks/use-is-small-screen"
import ProjectOverview from "./ProjectOverview"

const ProjectDashboard = ({ projectDashboard }: ProjectDashboardProps) => {
  const isSmallScreen = useIsSmallScreen()
  const classes = useStyles({ isSmallScreen })
  const translations = useTranslations()

  return (
    <div className={classes.viewContainer}>
      <section className={classes.paper}>
        <section className={classes.projectSection}>
          <ProjectOverview projectDashboard={projectDashboard} />
        </section>

        <section>
          <section className={classes.section}>
            <Typography variant="h5">{translations.tasksSectionHeader}</Typography>
          </section>
          <section className={classes.section}>
            <TasksOverview projectDashboard={projectDashboard} />
          </section>
          {projectDashboard.isOrgProject && (
            <section>
              <Card variant="outlined" className={classes.card}>
                <CardHeader
                  title={translations.resourceParticipationCardHeader}
                  className={classes.cardHeader}
                  disableTypography
                />
                <CardContent>
                  <ResourceParticipation projectDashboard={projectDashboard} />
                </CardContent>
              </Card>
            </section>
          )}
        </section>
      </section>
    </div>
  )
}

type StyleProps = {
  isSmallScreen: boolean
}

const useStyles = makeStyles<Theme, StyleProps>((theme) => ({
  viewContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
  paper: ({ isSmallScreen }) => ({
    padding: isSmallScreen ? theme.spacing(0.5) : theme.spacing(2),
    border: isSmallScreen ? "none" : `1px solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(0.5),
    maxWidth: APP_MAX_WIDTH,
    width: "100%",
  }),
  section: {
    marginBottom: theme.spacing(1),
  },
  projectSection: {
    marginBottom: theme.spacing(3),
  },
  card: {
    height: "100%",
  },
  cardHeader: {
    color: COLOR_GRAY,
    fontSize: "1rem",
  },
  cardContent: {
    fontWeight: 400,
  },
  pieChart: {
    padding: theme.spacing(0, 5),
  },
}))

export default ProjectDashboard
type ProjectDashboardProps = {
  projectDashboard: ProjectDashboardViewModel
}
